import React from 'react';

const Logo = ({ logo }) => <img src={logo} className="buroo-logo" alt="logo" />;

export default Logo;
